import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import cx from 'clsx';
import { useLocation } from 'react-router-dom';
import { debounce } from 'lodash';

import Button from '@/components/Button';
import { openInDebank } from '@/utils';

import styles from './index.module.scss';

export const DownloadBtn = (props: { className?: string }) => {
  const { t } = useTranslation();

  const { className } = props;
  const location = useLocation();

  const appLink = useMemo(() => {
    const urlAddress = location.pathname.match(
      /(profile|hi|proposal|official|stream|badge)\/([^/]+)/,
    )?.[2];
    const isHiChatPage = location?.pathname?.startsWith('/hi');
    const { pathname, search } = location;
    let interlink = 'assets';

    if (isHiChatPage) {
      interlink = `hi/${urlAddress}`;
    } else if (pathname?.includes('profile') && urlAddress) {
      interlink = `profile/${urlAddress}`;
    } else if (pathname?.startsWith('/proposal')) {
      interlink = `vote${urlAddress ? `/${urlAddress}` : ''}`;
    } else if (pathname.startsWith('/activity')) {
      interlink = pathname.replace(/^\//, '') + search;
    } else if (pathname.startsWith('/official') && urlAddress) {
      interlink = `official/${urlAddress}`;
    } else if (pathname.startsWith('/stream')) {
      interlink = (urlAddress ? `/stream/${urlAddress}` : '/stream') + search;
    } else if (pathname.startsWith('/badge')) {
      interlink = urlAddress ? `/badge/${urlAddress}` : '/badge';
    }

    return interlink;
  }, [location]);

  const handleClick = debounce(
    () => {
      openInDebank({ link: appLink });
    },
    500,
    { leading: true },
  );

  return (
    <>
      <Button className={cx(className, styles.downLoadBtn)} type="primary" onClick={handleClick}>
        {t('DownloadBtn.5tny8p')}
      </Button>
    </>
  );
};
